<template>
  <div class="chart-container" style="position: relative;" :style="`width: ${size.width}; height: ${size.height};`">
    <canvas :id="uuid" :width="size.width" :height="size.height" />
  </div>
  <v-sheet v-if="secret && local_data" class="my-5" color="grey-lighten-4">
    <v-btn v-on:click="update_chart(local_data)">ОБНОВИТЬ</v-btn>
    <template v-for="value of Object.keys(local_data)" :key="value">
      <v-switch v-if="typeof local_data[value] === 'boolean'" :label="value" v-model="local_data[value]" />
      <v-text-field :label="value + ' ' + typeof local_data[value]" v-model="local_data[value]" v-else />
    </template>
  </v-sheet>
</template>

<script>
import { Chart } from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { SecretBooba } from "@/store/SecretBooba";

export default {
  name: "4f5eab8e-8a13-11ef-8778-c85acf022408",
  props: ['chart', 'size', 'title', 'uuid'],
  mounted() {
    this.local_data = this.chart.report_data[0];
    this.canvas = document.getElementById(this.uuid).getContext('2d')
    this.make_chart()
  },
  data() {
    return {
      local_data: null,
      canvas: null,
      graph: null,
      titles: [],
      datasets: []
    }
  },
  computed: {
    secret() {
      return SecretBooba().get()
    },
    report_data() {
      return this.chart.report_data
    }
  },
  watch: {
    report_data() {
      this.local_data = this.chart.report_data[0];
      this.update_chart()
    }
  },
  methods: {
    make_chart: function () {
      this.update_data()
      if (this.canvas) {
        this.graph = new Chart(this.canvas, {
          type: 'bar',
          plugins: [ChartDataLabels],
          data: {
            labels: this.titles,
            datasets: this.datasets
          },
          options: {
            layout: {
              padding: {
                top: 25
              }
            },
            scales: {
              y: {
                beginAtZero: true,
                title: {
                  display: true,
                  text: 'Кол-во'
                },
              }
            },
            plugins: {
              datalabels: {
                anchor: 'end',
                clamp: true,
                align: 'end'
              },
              legend: {
                display: false
              },
            }
          }
        });
      }
    },
    update_data: function (report = this.chart.report_data[0]) {
      let razmaz = report['РАЗМАЗ']
      this.datasets = []
      this.titles = []

      let values_plan = []
      let values_fakt = []

      // ПЛАН

      values_plan.push(report['ПЛАН_ОБР_Инциденты'])
      values_plan.push(report['ПЛАН_ТОиР_ТО'])
      values_plan.push(report['ПЛАН_ТОиР_ИСП'])
      values_plan.push(report['ПЛАН_ОБР_Спец'])
      if (!razmaz) {
        values_plan.push(0)
      }
      values_plan.push(report['ПЛАН_Итого'])

      // ФАКТ
      if (razmaz) {
        values_fakt.push((parseFloat(report['ФАКТ_ОБР_Инциденты']) + parseFloat(report['ФАКТ_Прочее']) / 3).toFixed(2))
        values_fakt.push((parseFloat(report['ФАКТ_ТОиР_ТО']) + parseFloat(report['ФАКТ_Прочее'] ) / 3).toFixed(2))
        values_fakt.push((parseFloat(report['ФАКТ_ТОиР_ИСП']) + parseFloat(report['ФАКТ_Прочее']) / 3).toFixed(2))
      } else {
        values_fakt.push(report['ФАКТ_ОБР_Инциденты'])
        values_fakt.push(report['ФАКТ_ТОиР_ТО'])
        values_fakt.push(report['ФАКТ_ТОиР_ИСП'])
      }
      values_fakt.push(report['ФАКТ_ОБР_Спец'])
      if (!razmaz) {
        values_fakt.push(report['ФАКТ_Прочее'])
      }
      values_fakt.push(report['ФАКТ_Итого'])

      this.titles.push('Инциденты')
      this.titles.push('Тех. обслуживание')
      this.titles.push('Испытания')
      this.titles.push('Спец. задачи')
      if (!razmaz) {
        this.titles.push('Вне плана')
      }
      this.titles.push('Итого')

      this.datasets.push({
        label: this.chart_description,
        data: values_plan
      })

      this.datasets.push({
        label: this.chart_description,
        data: values_fakt
      })
    },
    update_chart: function () {
      this.update_data()
      this.graph.destroy()
      this.canvas = document.getElementById(this.uuid).getContext('2d')
      this.make_chart()
    }
  },
}
</script>
